import { Component, OnInit, ElementRef } from '@angular/core';
import * as d3 from 'd3';

@Component({
  standalone: false,
  selector: 'app-assessment-graph-data',
  templateUrl: './assessment-graph-data.component.html',
  styleUrls: ['./assessment-graph-data.component.css']
})
export class AssessmentGraphDataComponent implements OnInit {

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.createGraphSheet();
  }

  createGraphSheet() {
    const element = this.el.nativeElement;
    const svg = d3.select(element).append('svg')
      .attr('width', '100vw')
      .attr('height', '100vh');

    const width = element.offsetWidth;
    const height = element.offsetHeight;

    const gridSize = 20;

    // Create vertical lines
    for (let x = 0; x <= width; x += gridSize) {
      svg.append('line')
        .attr('x1', x)
        .attr('y1', 0)
        .attr('x2', x)
        .attr('y2', height)
        .attr('stroke', '#ccc')
        .attr('stroke-width', 1);
    }

    // Create horizontal lines
    for (let y = 0; y <= height; y += gridSize) {
      svg.append('line')
        .attr('x1', 0)
        .attr('y1', y)
        .attr('x2', width)
        .attr('y2', y)
        .attr('stroke', '#ccc')
        .attr('stroke-width', 1);
    }
  }
}
